export default __webpack_public_path__ + "static/media/126.b70269fa.png";